export class EmailRequest {
    to: string;
    from: string;
    message: string;
    subject: string;
    cc: string;
    bcc: string;
}
